import styled from '@emotion/styled';
import { navigation } from 'src/assets/colors';

export const LeftSideBar = styled('aside', { label: 'LeftSideBar' })`
    background-color: ${navigation.bgColor};
    height: calc(100vh - 56px);
    left: 0;
    padding: 8px;
    position: absolute;
    top: 56px;
    width: 248px;
    z-index: 1;
`;


export const SectionWrapper = styled('section', { label: 'SectionWrapper' })`
    margin: 5px 5px 5px 0;
    padding: 15px;
    background-color: ${navigation.bgColorTab};
`;
